<dialog-draggable-header>
  Update NEC Complete Date for Tool #: {{necData?.toolNo}} NEC LEC: {{necData?.necLec}}
</dialog-draggable-header>

<div>
  <mat-form-field>
    <mat-label>NEC Complete Date</mat-label>
    <input id="datepicker" matInput [matDatepicker]="datepicker" [formControl]="date" />
    <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
    <mat-datepicker [startAt]="date.value" #datepicker></mat-datepicker>
  </mat-form-field>
</div>

<div mat-dialog-actions class="justify-content-end">
  <button color="primary" mat-raised-button (keypress)="update()" (click)="update()" [disabled]="date.invalid">
    Update
  </button>
  <button mat-raised-button mat-dialog-close>Cancel</button>
</div>